






import { Vue, Component } from 'vue-property-decorator';

@Component
export default class LoginFooter extends Vue {
   redirectToRoute(routeName) {
    this.$cookies.remove('OAuthRegistrationType');
    this.$cookies.remove('OAuthProvider');
    this.$router.push({ name: routeName });
  }
};
